<template>
    <!-- Mobile version -->
    <BottomBg class="d-flex flex-column justify-content-between">
        <!-- Logo-->
        <HomeLogo/>

        <!-- Payoff -->
        <div class="home-content" v-if="!$auth.isLoggedIn()">
            <h2 class="payoff payoff-dark">
                Con LiRe scopri in pochi click quanto puoi ridurre i consumi Energetici
                dei tuoi clienti!
            </h2>

            <p>
                Ma non solo, hai anche la possibilità di ottenere una prima consulenza
                <strong>A COSTO ZERO</strong>, con uno degli esperti di gestione energetica di Lire.
            </p>

            <p class="home-subtitle">
                Perchè A COSTO ZERO?
            </p>

            <p>
                Perchè siamo una giovane start-up, e, per dimostrarti la
                bontà del nostro operato, abbiamo deciso di offrire ai primi utilizzatori della nostra
                applicazione un primo consulto, senza chiedere un solo euro in cambio.
            </p>
        </div>

        <h2 v-text="contents.payoff" class="payoff" v-else/>

        <div>
            <!-- Continue button -->
            <btn @click="gotoTypes()" :text="contents.start"/>

            <!-- Latest report button -->
            <btn @click="latestReport()" :text="contents.last_report"
                 v-if="hasLatestReport" class="mt-3"/>

            <!-- Logout for devs -->
            <btn v-if="isDev && $auth.isLoggedIn()" @click="exit()" text="Logout"
                 type="dev" :small="true" class="mt-3"/>
        </div>

    </BottomBg>
</template>

<script>
import {isDev} from "@/helpers";
import AuthStorage from "../services/AuthStorage";
import contents from "../contents/home.json"
import Btn from "../components/Btn";
import HomeLogo from "../components/HomeLogo";
import BottomBg from "../components/BottomBg";

export default {
    name: 'home',
    components: {Btn, HomeLogo, BottomBg},
    async mounted() {

        this.$registerEvent('Pagina', '1. Inizio analisi');

        // Skip this page for web desktop
        if (this.$web.isDesktop) {
            await this.$router.push('/vector')
        }

        // Load latest profile if not set already
        // and subscriber is logged in.
        if (this.$auth.isLoggedIn() && !this.$store.state.last_profile_UUID) {
            let subcriber = await this.$api.getAuthSubscriber();
            this.$store.commit('setProfileUUID', subcriber.last_profile_uuid);
        }
    },
    data() {
        return {contents};
    },
    methods: {
        gotoTypes() {
            this.$router.push('/vector');
        },
        latestReport() {
            this.$router.push('/report');
        },
        exit() {
            AuthStorage.resetTokens();
            this.$alert('Resettati i token di accesso.');
        }
    },
    computed: {
        isDev: () => isDev(),
        hasLatestReport() {
            return this.$store.state.last_profile_UUID && this.$auth.isLoggedIn();
        }
    }
};
</script>

<style lang="scss" scoped>
.home-content {
    margin: 40px 0 15px;
    text-align: center;
    color: #fff;
    font-size: 3.5vw;
}
.home-subtitle {
    font-size: 5vw;
}
.payoff {
    font-style: normal;
    font-weight: bold;
    margin: 3vh 0;
    text-align: center;
    line-height: 32px;
    font-size: 5vw;
    color: #fff;
}
.payoff-dark {
    color: #1c1c1c;
}
</style>